import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useRef, useState } from "react";
import { MdArrowBack, MdArrowLeft, MdArrowRight, MdAttachFile, MdClose, MdFileCopy, MdFilePresent, MdForward, MdForward10, MdForwardToInbox, MdReply, MdSend } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import { web_url } from "../../constant";


function ResearcherReadStudentEmail({ t }) {
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });

    const [content, setContent] = useState({
        messageId: "",
        threadId: "",
        subject: "",
        other: ''
    });


    const [messagesArray, setmessagesArray] = useState([
        {
            messageId: "",
            sender: "",
            body: "",
            status: "",
            sentAt: "",
            language: "",
            type: "",
            attachments: [],
            otherPerson: "",
            receiver: ''
        }
    ])
    const [indexOfMessageShowingNow, setIndexOfMessageShowingNow] = useState(0)

    const [isReceived, setIsReceived] = useState(false);

    const getLogDetails = () => {
        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    };
    const logDetails = getLogDetails();

    useEffect(() => {
        if (localStorage.getItem('mailsent')) {
            const mail = JSON.parse(localStorage.getItem('mailsent'));
            setContent(mail)
        } else if (localStorage.getItem('maildraft')) {
            const mail = JSON.parse(localStorage.getItem('maildraft'));
            setContent(mail)
        } else if (localStorage.getItem('mailreceived')) {
            const mail = JSON.parse(localStorage.getItem('mailreceived'));
            setContent(mail)
        } else {
            alert("no mail")
        }
    }, [])

    useEffect(() => {
        const studentMails = JSON.parse(localStorage.getItem('userSelected')).userEmail;
        if (messagesArray) {
            if (messagesArray[indexOfMessageShowingNow]?.receiver === studentMails) {
                // console.log("abi idiot 1");
                setIsReceived(true)
            } else {
                // console.log("abi idiot 2");
                setIsReceived(false)
            }
        }
    }, [indexOfMessageShowingNow, messagesArray])


    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('found')) {
            setError(t('t214'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
    };


    useEffect(() => {
        setIsLoading(true);
        if (content.threadId) {
            const getLogDetails = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails = getLogDetails();

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };
            axios.get(`${web_url}/api/email-threads/${content.threadId}`, configToken).then((response) => {
                // console.log("resnow", response.data);

                const sortedMessages = response.data.messages
                    .sort((a, b) => new Date(a.sentAt) - new Date(b.sentAt))
                    .map((message) => ({
                        ...message,
                        receiver: response.data.participants.find(email => email !== message.sender)
                    }));
                setmessagesArray(sortedMessages);
                setIsLoading(false);


            }).catch((err) => {
                handleClickOpenError('error occured')
                setIsLoading(false);
            })
        }
    }, [content])
    // console.log("this is tha response", messagesArray);


    // const formats = ["bold", "italic", "underline", "list", "bullet", "size"];

    const navigate = useNavigate();

    const [showLeftArrow, setShowLeftArrow] = useState(false)
    const [showRightArrow, setShowRightArrow] = useState(false)

    useEffect(() => {
        if (messagesArray) {
            if (messagesArray.length === 1) {
                setShowLeftArrow(false);
                setShowRightArrow(false);
                setIndexOfMessageShowingNow(0);
            } else {
                const index = messagesArray.findIndex((message) => message.messageId === content.messageId);
                setIndexOfMessageShowingNow(index);
            }
        }
    }, [messagesArray])

    useEffect(() => {
        if (messagesArray.length === 1) {
            setShowLeftArrow(false);
            setShowRightArrow(false);
            setIndexOfMessageShowingNow(0);
        } else {
            if (indexOfMessageShowingNow === (messagesArray.length) - 1) {
                setShowRightArrow(false);
            } else {
                setShowRightArrow(true);
            }

            if (indexOfMessageShowingNow === 0) {
                setShowLeftArrow(false);
            } else {
                setShowLeftArrow(true);
            }
        }

        // console.log('message', messagesArray[indexOfMessageShowingNow]);

    }, [indexOfMessageShowingNow, messagesArray])

    const handleRightArrow = () => {
        setIndexOfMessageShowingNow(indexOfMessageShowingNow + 1);
    }

    const handleLeftArrow = () => {
        setIndexOfMessageShowingNow(indexOfMessageShowingNow - 1);
    }


    const handleDownload = async (fileName, fileUrl) => {
        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    return (
        <>
            <div className="xl:bg-[#FFEBA9] xl:rounded-md mb-[200px] xl:mb-[10px] pl-[30px] xl:pl-[20px] xl:ml-[0px] 2xl:pl-[30px] pr-[30px] xl:pr-[20px] 2xl:pr-[30px] xl:mr-[80px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[1px] 2xl:pt-[5px] xl:pb-[20px] 2xl:pb-[30px] 2xl:pt-[0px] xl:mt-[20px] 2xl:mt-[30px]">
                <div className="flex items-center mt-[20px] lg:ml-[70px] xl:ml-[0px] justify-between">
                    <div className="flex items-center justify-between w-full  md:mr-[30px] lg:mr-[130px]">
                        <div className="flex items-center">
                            <MdArrowBack size={25} className="md:hidden" onClick={() => {
                                navigate('/mobile/researcher/student/mailprofile/view')
                            }} />
                            <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                                navigate('/mobile/researcher/student/mailprofile/view')
                            }} />
                            <p className="font-bold text-[20px] ml-[10px] md:text-[20px] lg:text-[25px] xl:text-[19px] 2xl:text-[25px]">{t('t234')}</p>
                        </div>
                        <div className="flex items-center">
                            {/* <MdReply onClick={handleReplyButton} size={30} className="mr-[10px] md:hidden" />
                            <MdReply onClick={handleReplyButton} size={40} className="mr-[10px] hidden md:block" /> */}

                            {
                                showLeftArrow &&
                                <>
                                    <MdArrowLeft onClick={handleLeftArrow} size={40} className="md:hidden" />
                                    <MdArrowLeft onClick={handleLeftArrow} size={50} className="hidden md:block" />
                                </>
                            }

                            {
                                showRightArrow &&
                                <>
                                    <MdArrowRight onClick={handleRightArrow} size={40} className="md:hidden" />
                                    <MdArrowRight onClick={handleRightArrow} size={50} className="hidden md:block" />
                                </>
                            }

                        </div>
                    </div>
                </div>

                {
                    isLoading ?
                        <div className="items-center justify-center flex pt-[30px]">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                        :
                        <>
                            <div className="flex items-center justify-center">
                                <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                    {isReceived &&
                                        <p className={`text-gray-500 text-[15px]`}>{t('t235')}:</p>
                                    }
                                    {!isReceived &&
                                        <p className={`text-gray-500 text-[15px]`}>{t('t220')}:</p>
                                    }
                                    {messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow]?.sender &&
                                        isReceived && <input value={messagesArray[indexOfMessageShowingNow].sender} readOnly type="text" name="receptionist" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"
                                        />
                                    }
                                    {
                                        messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] &&
                                        !isReceived && (
                                            <input
                                                value={messagesArray[indexOfMessageShowingNow].receiver || ""}
                                                readOnly
                                                type="text"
                                                name="receptionist"
                                                className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"
                                            />
                                        )
                                    }
                                </div>
                            </div>

                            <div className="flex items-center justify-center">
                                <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                    <p className={`text-gray-500 text-[15px]`}>{t('t236')}:</p>
                                    <input readOnly value={(content.subject.trim()) ? content.subject.trim() : "(No subject)"} type="text" name="subject" className={`ml-[10px] w-full bg-[#F1F6FB] text-[15px] ${content.subject.trim() ? 'text-gray-900' : 'text-gray-500'} placeholder:text-[#8189B0] focus:outline focus:outline-0`} placeholder={t('t224')}
                                    />
                                </div>
                            </div>

                            <div className="mt-[20px] md:pl-[100px] lg:pl-[200px] xl:pl-[10px] flex flex-col gap-[5px] mb-[10px]">
                                {
                                    messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] && messagesArray[indexOfMessageShowingNow]?.attachments &&
                                    <>
                                        {(messagesArray[indexOfMessageShowingNow].attachments).map((file, index) => (
                                            <div key={index} className="flex items-center justify-between">
                                                <div className="flex items-center cursor-pointer" onClick={() => handleDownload(file.fileName, file.fileUrl)}>
                                                    <MdFilePresent />
                                                    <p className="text-black text-[15px] md:text-[17px]">{file.fileName}</p>
                                                </div>

                                            </div>
                                        ))}
                                    </>
                                }
                            </div>

                            <div className="md:flex md:justify-center md:items-center">
                                {
                                    messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] && messagesArray[indexOfMessageShowingNow]?.body &&
                                    <div className="justify-center items-center">
                                        <ReactQuill
                                            modules={{ toolbar: false }}
                                            value={messagesArray[indexOfMessageShowingNow].body}
                                            readOnly
                                            theme="snow"
                                            placeholder={t('t225')}
                                            className="rounded-lg min-h-[400px] xl:min-h-[300px] 2xl:min-h-[500px] w-full md:w-[600px] xl:w-[390px] 2xl:w-[500px] mt-[5px] bg-[#F1F6FB] border border-gray-400 focus-within:shadow-[0_0_0_2px_rgba(156,163,175,1)]" />
                                    </div>
                                }
                            </div>
                        </>
                }

                {
                    content?.moderationRecord?.reason &&
                    <div className="md:flex md:justify-center md:items-center">
                        <div className="items-center mt-[20px] flex md:w-[600px] md:justify-center">
                            <textarea className={` rounded-md w-full bg-[#F1F6FB] text-[15px] text-[#1F2937] shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px] focus:border-none focus:outline-none py-[5px] px-[20px]`}
                                rows={7} cols={40}
                                placeholder="Reason for rejection"
                                readOnly
                                value={`Rejected reason : \n${JSON.parse(content?.moderationRecord?.reason || '{}')?.reason || ''}`}
                            />
                        </div>
                    </div>
                }

            </div >

        </>
    )
}

export default ResearcherReadStudentEmail;
